import {Auditable} from "../shared/auditable.model";
import {UserModel} from "./user.model";
import {FileModel} from "../shared/file.model";
import {CodeModel} from "./code.model";
import {TagModel} from "./tag.model";
import {AccountModel} from "./account.model";
import {SiteModel} from "./site.model";
import {VendorModel} from "./vendor.model";
import {AssetTypeModel} from "./asset-type.model";

export class AssetModel extends Auditable {
  id: number;
  name: string = '';
  hash_key: string;
  code_prefix: string = '';
  code: string;

  account_id: number;
  site_id: number;
  asset_type_id: number;
  vendor_id: number;
  contractor_account_id: number;

  status: string = 'active';
  description: string;
  location: string;

  owner_type: string = 'owned';
  owner_notes: string;

  account_currency_code: string;
  cost_amount: number;
  cost_frequency: string;
  cost_start_at: string;
  cost_end_at: string;

  serial_no: string;
  vehicle_reg_no: string;
  part_no: string;
  purchase_order_no: string;

  condition_rating: string = 'fair';
  noise_rating_db: number;
  emissions_class: string;
  emergency_shutdown_procedure: string;

  enable_compliance_documents: boolean = false;
  enable_maintenance_records: boolean = false;
  enable_schedules: boolean = false;
  enable_repair_history: boolean = false;
  enable_usage_logs: boolean = false;
  enable_depreciation_logs: boolean = false;

  is_mobile: boolean = false;
  is_safety_critical: boolean = false;
  is_visible: boolean = true;
  site_manager_can_edit: boolean = true;

  notes: string;

  lifecycle_end_at: string;
  lifecycle_end_reason: string;

  expected_replacement_at: string;
  warranty_expiry_date: string;
  maintenance_due_date: string;
  next_inspection_due_date: string;

  last_inspection_at: number;

  main_image_name: string;
  main_image_url: string;
  thumbnail_image_url: string;

  site_name: string;
  employer_name: string;
  asset_type_name: string;
  parent_asset_type_name: string;

  created_by_user: UserModel;
  updated_by_user: UserModel;

  account: AccountModel;
  asset_type: AssetTypeModel;
  site: SiteModel;
  contractor_owner: AccountModel;
  vendor: VendorModel;

  contractors: AccountModel[] = [];
  users: UserModel[] = [];
  tags: TagModel[] = [];
  qr_code: CodeModel;
  files: FileModel[] = [];

  contractor_ids: number[] = [];
  user_ids: number[] = [];
  tag_ids: number[] = [];
}
